export default {
  badge: 'Test',
  badge_title: 'Restauracja testowa',
  notice: 'To jest restauracja testowa. Zamówienia złożone tutaj służą wyłącznie do testów.',
};
